import { Cancel, Check } from "@mui/icons-material"
import { ContentForm, FormCad } from "../../../../components/viewCadastro/formCad"
import { ItemMov } from "../../mov.model"
import Modal from "../../../../components/modal"

interface ItemMovViewProps {
    itemMov: ItemMov,
    confirme: (row: ItemMov) => any
    remove: (row: ItemMov) => any
    open: boolean,
    handleClose: () => any
}

export const ViewCadastroItemMov = (props: ItemMovViewProps) => {
    const { confirme, remove, itemMov, handleClose, open } = props

    const handleSubmit = (mov: ItemMov) => {
        console.log("confirma item mov", mov)
        confirme(mov);
        handleClose();
    }

    const handleRemove = (row:ItemMov) => {
        remove(row);
        handleClose();
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        let itemMov: ItemMov = state.formState.values;
        let total = itemMov.total;
        let valor = itemMov.valor
        let qt = itemMov.qt;
        if (field === "qt") {
            changeValue(state, "total", () => value * valor)
        }
        if (field === "valor") {
            changeValue(state, "total", () => qt * value)
        }
        changeValue(state, field, () => value)
    }

    const Content = () => (
        <FormCad
            handleOnSubmit={handleSubmit}
            //formValidation={}
            handleMutator={handleMutator}
            handleCancel={() => { }}
            row={itemMov}
            contentForm={[
                { fieldName: "item.codigo", label: "Código", type: "text", key: "codigo", colunsXS: 3, colunsSM: 3, colunsMD: 3, disabled: true },
                { fieldName: "item.descricao", label: "Descrição", type: "text", key: "nome", colunsXS: 8, colunsSM: 8, colunsMD: 8, disabled: true },
                { fieldName: "qt", label: "Qtde.", type: "number", key: "qt", colunsXS: 3, colunsSM: 3, colunsMD: 3, autoFocus: true, handleChangeMutator: (func, value) => func(value, "qt") },
                { fieldName: "valor", label: "Preço", type: "currency", key: "valor", colunsXS: 3, colunsSM: 3, colunsMD: 3, handleChangeMutator: (func, value) => func(value, "valor") },
                { fieldName: "total", label: "Total", type: "currency", key: "total", colunsXS: 3, colunsSM: 3, colunsMD: 3, handleChangeMutator: (func, value) => func(value, "total") },
                { fieldName: "item.tabela_preco.type", label:"Origem Preço", type:"chip", key:"tabela", colunsXS: 3, colunsSM: 3, colunsMD: 3, tip:"Origem do preço" }

            ]}
            buttonActions={[
                { label: "Remover", icon: <Cancel />, color: "error", variant: "contained", handleOnClick: (row) => handleRemove(row), disableType: "personalizado", disabled: (mov: any) => !mov._id },
                { label: "Confirmar", icon: <Check />, color: "success", variant: "contained", type: "submit", disableType: "padraoForm" }

            ]}
            ContentBox={(props) => {
                const itemMov: ItemMov = props&&props.values
                if (itemMov.item && itemMov.item.info_dt_validade)
                    return (
                        <ContentForm fieldName={"ano_validade"} type="number" label="Ano Vencimento" colunsXS={3} colunsSM={3} colunsMD={3} require={true} />
                    )
                return <div></div>
            }}
        />
    )

    return (
        <Modal
            component={<Content />}
            handleClose={handleClose}
            open={open}
            width="sm"
            heigth="auto"
            handleOnKeyDown={(ev) => {
                console.log("ev", ev)
            }}
        />
    )
}